// src/AuthContext.tsx
import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { format } from "date-fns";
import { updateToken } from "./ApolloClient";

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

// type User = { email: string; id?: string; access_type?: string };

type AuthContextType = {
  userInfo: any | null;
  login: (userData: any) => void;
  logout: () => void;
  updateUserInfo: (updatedFields: Partial<any>) => void;
  isLoading: boolean;
  // Calendar states
  startDateCalendar: string;
  setStartDateCalendar: React.Dispatch<React.SetStateAction<string>>;
  startDateCalendarDay: string;
  setStartDateCalendarDay: React.Dispatch<React.SetStateAction<string>>;
  endDateCalendar: string;
  setEndDateCalendar: React.Dispatch<React.SetStateAction<string>>;
  calendarDate: { start: string; end: string };
  setCalendarDate: React.Dispatch<React.SetStateAction<{ start: string; end: string }>>;
  currentView: string;
  setCurrentView: React.Dispatch<React.SetStateAction<string>>;
  calendarFilter: number;
  setCalendarFilter: React.Dispatch<React.SetStateAction<number>>;
  radioType: string;
  setRadioType: React.Dispatch<React.SetStateAction<string>>;
  selectedItem: string;
  setSelectedItem: React.Dispatch<React.SetStateAction<string>>;
  taskFilter: string; setTaskFilter: React.Dispatch<React.SetStateAction<string>>;
  goalFilter: string; setGoalFilter: React.Dispatch<React.SetStateAction<string>>;
  selectedEmployee:string;
  setSelectedEmployee:React.Dispatch<React.SetStateAction<string>>;
  currentViewAdmin:string; setCurrentViewAdmin:React.Dispatch<React.SetStateAction<string>>;
  isAdmin:any;
  developmentUser:any;
  currentPageTask:any; setCurrentPageTask:any
  activeTab:any; setActiveTab:any
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [userInfo, setUserInfo] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("userInfo");
    if (storedUser) {
      setUserInfo(JSON.parse(storedUser));
      // updateToken(userData?.token);
    }
    setIsLoading(false);
  }, []);

  function login(userData: any): void {
    updateToken(userData?.token);
    setUserInfo(userData);
    localStorage.setItem("userInfo", JSON.stringify(userData));
  };

  function logout(): void {
    setUserInfo(null);
    localStorage.removeItem("userInfo");
  };

  function updateUserInfo(updatedFields: Partial<any>): void {
    if (!userInfo) return; // No user yet

    const updatedUser = { ...userInfo, ...updatedFields };
    setUserInfo(updatedUser);
    localStorage.setItem("userInfo", JSON.stringify(updatedUser));
  }

  // Calendar state setup
  const formattedDate = format(new Date(), "yyyy-MM-dd");
  const [startDateCalendar, setStartDateCalendar] = useState(formattedDate);
  const [startDateCalendarDay, setStartDateCalendarDay] = useState(formattedDate);
  const [calendarDate, setCalendarDate] = useState({ start: formattedDate, end: formattedDate });
  const [endDateCalendar, setEndDateCalendar] = useState(formattedDate);
  const [currentView, setCurrentView] = useState("timelineDay");
  const [calendarFilter, setCalendarFilter] = useState(0);
  const [radioType, setRadioType] = useState("");
  const [selectedItem, setSelectedItem] = useState("Dashboard");
  const [taskFilter, setTaskFilter] = useState<string>("All");
  const [goalFilter, setGoalFilter] = useState<string>("All");
  const [selectedEmployee,setSelectedEmployee] = useState<string>("All");
  const [currentViewAdmin, setCurrentViewAdmin] = useState("resourceTimelineDay");
  const users = ["1000006","1000108","1000012","1000099","1000004","1000003","1000005","1000029"]
  const isAdmin = users?.includes(userInfo?.employee_id)
  const developmentUser = userInfo?.employee_id == "1000108"


    //For Action Page Task
    const [currentPageTask, setCurrentPageTask] = useState(0); // pagination state


    //For the resource page
      const [activeTab, setActiveTab] = useState("Overview");


  // Auto update radio type on login
  useEffect(() => {
    if (userInfo?.access_type) {
      setRadioType(userInfo.access_type === "Assessor" ? "Assessor" : "Clients");
    }
  }, [userInfo]);

  return (
    <AuthContext.Provider
      value={{
        userInfo: userInfo,
        login,
        logout,
        updateUserInfo,
        isLoading,
        startDateCalendar,
        setStartDateCalendar,
        startDateCalendarDay,
        setStartDateCalendarDay,
        endDateCalendar,
        setEndDateCalendar,
        calendarDate,
        setCalendarDate,
        currentView,
        setCurrentView,
        calendarFilter,
        setCalendarFilter,
        radioType,
        setRadioType,
        selectedItem,
        setSelectedItem,
        taskFilter, setTaskFilter,
        goalFilter, setGoalFilter,
        selectedEmployee,setSelectedEmployee,
        currentViewAdmin, setCurrentViewAdmin,
        isAdmin,
        developmentUser,
        currentPageTask, setCurrentPageTask,
        activeTab, setActiveTab
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
